import {PureComponent} from "react"
import PropTypes from "prop-types"

export default class SetAuthStatus extends PureComponent {
  static propTypes = {
    setAuthed: PropTypes.func.isRequired,
    unauthed: PropTypes.bool,
    noauth: PropTypes.bool
  }

  static defaultProps = {
    unauthed: false,
    noauth: false
  }

  componentDidMount() {
    const {setAuthed, unauthed, noauth} = this.props
    setAuthed({authed: !unauthed, noauth})
  }

  render() {
    return null
  }
}
